import React from "react";
import { NavLink } from "react-router-dom";

const TABS = [
  { to: "/admin", label: "Products" },
  { to: "/admin/catalog", label: "Catalog Pages" },
  { to: "/admin/settings", label: "Contact Details" },
];

export default function AdminNav() {
  return (
    <nav className="border-b border-slate-200 bg-white">
      <div className="mx-auto flex max-w-6xl gap-1 px-4 sm:px-6">
        {TABS.map((tab) => (
          <NavLink
            key={tab.to}
            to={tab.to}
            end
            className={({ isActive }) => `border-b-2 px-4 py-3 text-sm font-medium transition-colors ${
              isActive
                ? "border-maroon-700 text-maroon-700"
                : "border-transparent text-slate-500 hover:text-maroon-700"
            }`}
          >
            {tab.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
